/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './aldrete-score.reducer';

export const AldreteScoreDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const aldreteScoreEntity = useAppSelector(state => state.aldreteScore.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="aldreteScoreDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.aldreteScore.detail.title">AldreteScore</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.aldreteScore.id">Id</Translate>
            </span>
          </dt>
          <dd>{aldreteScoreEntity.id}</dd>
          <dt>
            <span id="activity">
              <Translate contentKey="tinyMedicRestApp.aldreteScore.activity">Activity</Translate>
            </span>
          </dt>
          <dd>{aldreteScoreEntity.activity}</dd>
          <dt>
            <span id="breathing">
              <Translate contentKey="tinyMedicRestApp.aldreteScore.breathing">Breathing</Translate>
            </span>
          </dt>
          <dd>{aldreteScoreEntity.breathing}</dd>
          <dt>
            <span id="circulation">
              <Translate contentKey="tinyMedicRestApp.aldreteScore.circulation">Circulation</Translate>
            </span>
          </dt>
          <dd>{aldreteScoreEntity.circulation}</dd>
          <dt>
            <span id="consciousness">
              <Translate contentKey="tinyMedicRestApp.aldreteScore.consciousness">Consciousness</Translate>
            </span>
          </dt>
          <dd>{aldreteScoreEntity.consciousness}</dd>
          <dt>
            <span id="oxygenSaturation">
              <Translate contentKey="tinyMedicRestApp.aldreteScore.oxygenSaturation">Oxygen Saturation</Translate>
            </span>
          </dt>
          <dd>{aldreteScoreEntity.oxygenSaturation}</dd>
          <dt>
            <span id="color">
              <Translate contentKey="tinyMedicRestApp.aldreteScore.color">Color</Translate>
            </span>
          </dt>
          <dd>{aldreteScoreEntity.color}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.aldreteScore.active">Active</Translate>
            </span>
          </dt>
          <dd>{aldreteScoreEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.aldreteScore.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{aldreteScoreEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.aldreteScore.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{aldreteScoreEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.aldreteScore.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{aldreteScoreEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.aldreteScore.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{aldreteScoreEntity.cursor}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.aldreteScore.patient">Patient</Translate>
          </dt>
          <dd>{aldreteScoreEntity.patient ? aldreteScoreEntity.patient.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/aldrete-score" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/aldrete-score/${aldreteScoreEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default AldreteScoreDetail;
